import { get } from 'lodash';
import * as validator from 'validator';

export async function validate(data, validators, otherErrors) {
  const errors = [...getValidationErrors(data, validators), ...otherErrors];

  return errors.length > 0 ? Promise.reject({ status: 400, validationErrors: errors }) : Promise.resolve();
}

export function getValidationErrors(data, validators) {
  const errors = [];

  validators.map((entry) => {
    if (entry.validator) {
      if (entry.field) {
        checkValidator(entry.field, entry.validator, get(data, entry.field), entry.message, errors);
      } else {
        checkValidator('object', entry.validator, data, entry.message, errors);
      }
    } else {
      const field = Object.keys(entry)[0];
      checkValidator(field, entry[field], get(data, field), entry.message, errors);
    }
  });

  return errors;
}

function checkValidator(field, validator, value, message, errors) {
  if (!validator(value)) {
    errors.push({
      field: field,
      message: message || getDefaultMessage(validator),
    });
  }
}

function getDefaultMessage(validator) {
  if (validator == notEmpty) return 'Can\'t be blank';
  if (validator == emptyOrEmail || validator == validEmail) return 'Invalid email address';

  return 'invalid';
}

export function notEmpty(str: string) {
  return str != null && str.toString().trim() != '';
}

export function lengthNoMoreThan(field: string, name: string, length: number) {
  return {
    [field]: (value: string) => !value || value.length <= length,
    message: `${name} cannot be more than ${length} characters`,
  };
}

export function validEmail(value: string) {
  return value && validator.isEmail(value);
}

export function emptyOrEmail(value: string) {
  return !value || validator.isEmail(value);
}

export function validInteger(value: string) {
  return /^\d+$/.test(value);
}

export function isDecimal(value: string) {
  return /^[-+]?[0-9]+\.[0-9]+$/.test(value);
}

export function validCurrency(value: string) {
  return /^[0-9]+(\.)?([0-9]{1,2})?$/.test(value);
}
